import React from "react";
import { CButton, CCol, CContainer, CRow } from "@coreui/react";
import notfound from "../../../assets/images/404.svg";
import arrow from "../../../assets/images/right.svg";
import "./404.css";
import { useHistory } from "react-router-dom";
const Page404 = ({ showButton }) => {
  let history = useHistory();
  return (
    <div
      className="c-app c-default-layout flex-row align-items-center"
      style={{ backgroundColor: "#F6F2FE" }}
    >
      <CContainer>
        <CRow className="justify-content-center">
          <CCol className="Cont404" sm="12">
            <div className="contAll">
              <center>
                <img src={notfound} alt="notfound" />
              </center>

              <p className="erreur"> Une erreur est survenue </p>
              <p className="erreurcontenu"> Contenu introuvable </p>
              <p className="para404">
                {" "}
                Vous avez été trompé en cliquant sur un lien qui ne peut être
                trouvé.
              </p>

              {showButton != false && (
                <CButton
                  className="RetourButt"
                  onClick={() => {
                    localStorage.clear();
                    history.push("login");
                  }}
                >
                  Retourner a l'accueil
                  <img
                    className="retourimbutt"
                    alt="retourimbutt"
                    src={arrow}
                  />
                </CButton>
              )}
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default Page404;
